import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function ToolboxThumbnail(props) {
  const { src, title, url, onClick } = props;

  return (
    <Root onClick={onClick}>
      <Link href={url} target="blank">
        <img src={src} alt="thumbnail" />
        <Title>{title}</Title>
      </Link>
      {/* <Category>服務：<a href={url} target="blank">{category}</a></Category> */}
    </Root>
  )
}

ToolboxThumbnail.propTypes = {
  src: PropTypes.any,
  title: PropTypes.string,
  onClick: PropTypes.func
}

const Root = styled.div`
  ${vw('margin', 10)}

  &:hover {
    > a > h3 {
      color: #3398DC;
    }
  }

  
`;

const Link = styled.a`
  outline: none;

  > img {
    width: 100%;
    height: auto;
    
    ${vw('max-width', 310, 203, 203)}
    ${vw('max-height', 155, 110, 110)}
    ${vw('min-height', 80, 90, 110)}
    ${vw('margin-bottom', 10)}
  }

  > h3 {
    transition: all 0.25s ease-out;
  }

  > p {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #252525;
    transition: all 0.25s;

    ${vw('font-size', 10, 14)}
    ${vw('line-height', 18, 25)}
  }
`;

const Title = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  line-height: 180%;
  color: #252525;

  ${vw('font-size', 10, 14)}
`;

// const Category = styled.div`
//   font-family: 'Noto Sans TC';
//   font-style: normal;
//   font-weight: 400;
//   line-height: 180%;
//   color: #757575;

//   ${vw('font-size', 10, 12)}

//   > a {
//     color: #3398DC;
//     position: relative;

//     cursor: pointer;

//     &:before {
//       content: '';
//       width: 0;
//       height: 1px;
//       background: #3398DC;
//       position: absolute;
//       bottom: -2px;
//       left: 0;
//       transition: width 0.4s ease-out;
//     }

//     &:hover {
//       &:before {
//         width: 100%;
//       }
//     }
//   }
// `;

export default ToolboxThumbnail
